import { render } from "./Policy.vue?vue&type=template&id=01e76a41&scoped=true"
const script = {}

import "./Policy.vue?vue&type=style&index=0&id=01e76a41&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e76a41"]])

export default __exports__